import script from "./epgDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./epgDetail.vue?vue&type=script&lang=ts&setup=true"

import "./epgDetail.vue?vue&type=style&index=0&id=0474d407&lang=less"

const __exports__ = script;

export default __exports__